export default "__VITE_ASSET__D3hT9BsY__"